import { render, staticRenderFns } from "./ControleMaioridadeManutencao.vue?vue&type=template&id=73848a98&scoped=true&"
import script from "./ControleMaioridadeManutencao.vue?vue&type=script&lang=js&"
export * from "./ControleMaioridadeManutencao.vue?vue&type=script&lang=js&"
import style0 from "./ControleMaioridadeManutencao.vue?vue&type=style&index=0&id=73848a98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73848a98",
  null
  
)

export default component.exports